import { withValidate } from "./withValidate";
import { ThemedButton } from "./Button";
import { twMerge } from "tailwind-merge";
import { MouseEvent, useEffect, useState } from "react";
export interface SelectOption {
  value: string;
  label: string | React.ReactNode;
  disabled?: boolean;
}
export interface SelectProps {
  max?: number;
  options: SelectOption[];
  col?: number;
  defaultValues?: string[];
  onChange?: (value: string[]) => unknown;
  className?: string;
  ThemedClassName?: string;
}
export const Select = ({
  defaultValues = [],
  max,
  onChange,
  options,
  col = 3,
  className,
  ThemedClassName,
}: SelectProps) => {
  const [values, setValues] = useState(defaultValues);

  // defaultValues가 변경될 때마다 values 상태 업데이트
  useEffect(() => {
    setValues(defaultValues);
  }, [defaultValues]);

  const handleChange = (e: MouseEvent) => {
    // onChange?.bind(null, option.value)
    const target = e.target;
    if (target instanceof HTMLElement) {
      const value = target.dataset.value;
      if (!value) return;
      // if (max && values.length >= max) {
      //   if (values.includes(value)) {
      //     setValues(values.filter((v) => v !== value));
      //   } else {
      //     return;
      //   }
      if (max == 0) {
        return;
      }
      if (values.includes(value)) {
        setValues(values.filter((v) => v !== value));
      } else {
        const exValues = [...values];
        if (max && values.length >= max) exValues.shift();
        console.log(exValues)
        setValues([...exValues, value]);
      }
    }
  };
  useEffect(() => {
    onChange?.(values);
  }, [values]);
  return (
    <div
      className={twMerge("grid gap-2", className)}
      style={{
        gridTemplateColumns: `repeat(${col}, minmax(0, 1fr))`,
      }}
    >
      {options?.map((option) => (
        <ThemedButton
          data-value={option.value}
          onClick={handleChange}
          className={twMerge(
            !values?.includes(option.value) && "border-[#999] text-[#999999]",
            ThemedClassName
          )}
          color="secondary"
          type="button"
          key={option.value}
        >
          {option.label}
        </ThemedButton>
      ))}
    </div>
  );
};
export const ValidateSelect = withValidate(Select);

// export const Select = Object.assign(SelectRoot, {
//   Validate: ValidateSelect,
//   Check,
//   CheckWrap,
//   ValidateCheckWrap,
// });
